import { defineComponent as _defineComponent } from 'vue'
import SidebarContent from '@/components/SidebarContent.vue';
import RecommendUserForProjects from '@/views/recommendations/components/recommend-user-for-projects/RecommendUserForProjects.vue';
import ProfileSidebarTitle from '@/views/profile/components/sidebar/ProfileSidebarTitle.vue';
import useRecommendations from '@/views/profile/composables/useRecommendations';
import { computed, ref } from 'vue';
import useUser from '@/mixins/useUser';
import { UserType } from '@/models/User';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSidebar',
  props: {
  inBox: {
    type: Boolean
  }
},
  setup(__props) {



const isOpened = ref(true);
const { availability, sidebarType, user } = useRecommendations();
const {
  displayName: userName,
  type: userType
} = useUser(user);
const { type: currentUserType } = useUser('self');

// const isVisible = ref(false);
//
// watchEffect(() => {
//   if (
//     isCustomer.value !== undefined
//         && isGuest.value !== undefined
//         && isCurrentUserFreelancer.value !== undefined
//   ) {
//     isVisible.value = !isCustomer.value && isCurrentUserFreelancer.value && !isGuest.value;
//   } else {
//     isVisible.value = false;
//   }
// });

const isVisible = computed(
  () => userType.value === UserType.FREELANCER
    && currentUserType.value === UserType.FREELANCER
);

return { __sfc: true,isOpened, availability, sidebarType, user, userName, userType, currentUserType, isVisible, SidebarContent, RecommendUserForProjects, ProfileSidebarTitle }
}

})